"use client";
import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { useConsentManager } from "../../../../hooks/useConsentManager/index.js";
import { TRANSCEND_BUTTON_ID, COMPONENT_NAME } from "./constants.js";
const TranscendButton = ({
  entry
}) => {
  var _a, _b;
  const { openErrorDrawer } = useConsentManager();
  function handleClick() {
    if (typeof window !== "undefined" && typeof window.CostcoConsentManager !== "undefined") {
      window.CostcoConsentManager.openDrawer();
    } else {
      console.error(
        "CostcoConsentManager is not available on the window object"
      );
      openErrorDrawer();
    }
  }
  const buttonTitle = (_b = (_a = entry == null ? void 0 : entry.active_state) == null ? void 0 : _a.active_state_link) == null ? void 0 : _b.title;
  return /* @__PURE__ */ jsx(
    Button,
    {
      "data-testid": COMPONENT_NAME,
      id: TRANSCEND_BUTTON_ID,
      uniqueId: "cookie-settings",
      variant: "text-button",
      onClick: handleClick,
      children: buttonTitle
    }
  );
};
export {
  TranscendButton
};
